<template>
  <div>
    <v-container>
      <perseu-card title="Tipos de Fluxo">
        <template slot="title-right">
          <v-btn @click="create" color="secondary"> Novo Tipo de Fluxo </v-btn>
        </template>
        <template slot="content">
          <v-switch v-model="query.active" label="Ativos" @change="find" />
          <v-data-table :items="items" :headers="headers" class="elevation-1">
            <template v-slot:item.actions="{ item }">
              <table-action-button
                text="Editar"
                @click="edit(item)"
                icon="edit"
              />
              <table-action-button
                v-if="item.active"
                text="Desativar"
                @click="activeOrDeactivate(item, false)"
                icon="delete"
              />
              <table-action-button
                v-else
                text="Ativar"
                @click="activeOrDeactivate(item, true)"
                icon="check"
              />
            </template>
          </v-data-table>
        </template>
      </perseu-card>
    </v-container>
    <form-flow-type ref="form" @close="save" />
  </div>
</template>

<script>
import {
  findAll,
  findOne,
  update,
  create,
} from "@/services/flow-types-service.js";

export default {
  components: {
    "form-flow-type": () => import("@/components/FlowTypes/Form"),
  },
  data: () => ({
    items: [],
    headers: [
      { text: "Nome", value: "name" },
      {
        text: "Ações",
        value: "actions",
        width: 150,
        sortable: false,
        align: "start",
      },
    ],
    query: {
      active: true,
    },
  }),
  created() {
    this.find();
  },
  methods: {
    async find() {
      try {
        this.$store.dispatch("loading/openDialog");
        const { data } = await findAll(this.query);
        this.items = data;
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    async activeOrDeactivate(item, option) {
      try {
        this.$store.dispatch("loading/openDialog");
        item.active = option;
        await update(item);
        const index = this.findIndexItems(item);
        this.items.splice(index, 1);
      } catch (e) {
        this.$errorHandler(e);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    async edit(item) {
      this.$store.dispatch("loading/openDialog");
      try {
        const { data } = await findOne(item.id);
        this.$refs.form.edit(data);
      } catch (e) {
        this.$errorHandler(e);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    create() {
      this.$refs.form.create();
    },
    async save(flowType) {
      try {
        this.$store.dispatch("loading/openDialog");
        if (flowType.id) {
          const { data } = await update(flowType);
          const index = this.findIndexItems(flowType);
          this.items.splice(index, 1, data);
        } else {
          const { data } = await create(flowType);
          this.items.push(data);
        }
        this.$toasted.global.defaultSuccess();
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    findIndexItems(itemSelected) {
      return this.items.findIndex((item) => item.id === itemSelected.id);
    },
  },
};
</script>

<style></style>
